const noop = () => {
  return;
};

export default noop;
